import React, { Fragment, useEffect, useRef, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ProfileBox from "../components/ProfileBox";
import PageNameBox from "../components/PageNameBox";
import { checkPermission, fetchData, getFullName } from "../js/main";
import { Box, Button, Divider, Icon, LinearProgress } from "@mui/material";
import axios from "axios";
import Conf from "../Conf";

export default function UploadStudentPicture(props) {
  const [profile, setProfile] = useState();
  useEffect(() => {
    (async () => {
      if (props.profile && props.page) {
        let permission = await checkPermission(props.profile, props.page.path);
        if (permission === true) {
          setProfile(props.profile);
        }
      }
    })();
  }, [props]);
  return (
    <div className="content">
      {profile && (
        <>
          <div style={{ textAlign: "right" }}>
            <ProfileBox profile={profile} />
          </div>
          <PageNameBox page={props.page} />
          <br />
          <MultiFileUpload />
        </>
      )}
    </div>
  );
}

function MultiFileUpload() {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [students, setStudents] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const fileInputRef = useRef(null);

  function convertFile2Base64(file) {
    return new Promise(async (resolve) => {
      const reader = new FileReader();
      reader.onload = async function (e) {
        const base64String = e.target.result;
        resolve(base64String);
      };
      reader.readAsDataURL(file);
    });
  }
  const handleFileChange = async (event) => {
    setDisabled(true);
    const files = event.target.files;
    if (files) {
      // แปลง FileList เป็น Array เพื่อให้ง่ายต่อการจัดการ
      let student_codes = [];
      //   console.log(students);
      for (const file of files) {
        const student_code = file.name.split(".")[0];
        student_codes.push(student_code);
      }
      let Students = await fetchData("post", "/query", {
        collection: "students",
        match: { student_code: { $in: student_codes } },
        select: "student_code prefix first_name last_name nickname",
      });
      for (const file of files) {
        const student_code = file.name.split(".")[0];
        const key = await Students.result.findIndex(
          (j) => j.student_code === student_code
        );
        if (key > -1) {
          Students.result[key].preview = URL.createObjectURL(file);
          Students.result[key].fullname = await getFullName(
            Students.result[key]
          );
          Students.result[key].file = await convertFile2Base64(file);
        }
      }
      setStudents(Students.result);
      setSelectedFiles(Array.from(files));
      setDisabled(false);
    }
  };

  async function upload(student) {
    return new Promise(async (resolve) => {
      const file = student.file;
      if (file) {
        let path = await axios.put(Conf.endpoint.fileUpload, {
          file_stream: file,
          file_type: "student",
        });
        resolve("file.php?id=" + path.data._id);
      } else resolve(false);
    });
  }

  const handleUploadClick = async () => {
    setDisabled(true);
    // โค้ดสำหรับส่งไฟล์ไปยัง Back-end
    if (students.length > 0) {
      let Students = JSON.parse(JSON.stringify(students));
      let key = 0;
      for (let student of students) {
        let result = await upload(student);
        if (result !== false) {
          result = await fetchData("put", "/student", {
            _id: student._id,
            photo_url: result,
          });
        }
        Students[key].uploaded = true;
        setStudents(Students);
        key++;
      }
      alert("Upload Completed");
    } else {
      alert("กรุณาเลือกไฟล์ก่อน");
    }
    setDisabled(false);
  };
  return (
    <div>
      {disabled === true && <LinearProgress />}
      <Box sx={{ p: 2, border: "1px dashed grey", borderRadius: 1 }}>
        <div style={{ fontWeight: "500", marginBottom: "15px" }}>
          กรุณาเปลี่ยนชื่อไฟล์เป็นรหัสนักเรียนก่อนการ Upload
        </div>
        <input
          type="file"
          multiple
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }} // ซ่อน input จริงไว้
        />
        <Button
          variant="contained"
          sx={{ width: "200px" }}
          onClick={() => fileInputRef.current.click()}
          disabled={disabled}
        >
          <div>เลือกไฟล์รูปภาพ</div>
        </Button>
        {students && students[0] && (
          <>
            <div
              style={{
                fontSize: "1.2rem",
                fontWeight: "500",
                marginTop: "20px",
                color: "#888",
              }}
            >
              Found {students.length} students :
            </div>
            <List
              sx={{
                width: "100%",
                bgcolor: "background.paper",
                margin: "10px auto 20px",
              }}
            >
              {students.map((student, key) => (
                <Fragment key={key}>
                  <ListItem>
                    <ListItemAvatar sx={{ minWidth: "90px" }}>
                      {student.uploaded === true ? (
                        <Icon sx={{ fontSize: "4rem", color: "#0a0" }}>
                          check_circle
                        </Icon>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            backgroundImage: `url(${student.preview})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center center",
                            border: `1px solid #ccc`,
                            borderRadius: "50%",
                          }}
                        ></div>
                      )}
                    </ListItemAvatar>
                    <ListItemText>
                      <div>{student.fullname}</div>
                      <div>Nickname : {student.nickname}</div>
                    </ListItemText>
                  </ListItem>
                  {key < students.length - 1 && <Divider />}
                </Fragment>
              ))}
            </List>
          </>
        )}
        <div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUploadClick}
            sx={{ mt: 2, width: "200px" }}
            disabled={selectedFiles.length === 0 || disabled}
          >
            <div>อัปโหลดไฟล์</div>
          </Button>
        </div>
      </Box>
    </div>
  );
}
